import './PromoImageView.css';
import promo1 from '../../assets/images/LauriMikael1.jpg';
import promo2 from '../../assets/images/IMG_0602.jpg';
import promo3 from '../../assets/images/LauriMikael2.jpg';
import promo4 from '../../assets/images/LauriMikael3.jpg';
import promo5 from '../../assets/images/IMG_0081.jpg';
import { useMemo, useState } from 'react';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slider from 'react-slick';
import { useWindowSize } from '../../hooks/useWindowSize';
import classNames from 'classnames';

const promoPhotos = [
  promo3,
  promo1,
  promo2,
  promo4,
  promo5,
];

const getSlideCount = (width: number) => {
  if (width >= 640) {
    return 3;
  }
  return 1;
}

const PromoImageView = () => {

  const windowSize = useWindowSize();

  const [fullImage, setFullImage] = useState<string | null>(null);
  const [upcomingSlide, setUpcomingSlide] = useState(0);

  const sliderSettings = useMemo(() => {
    return {
      centerMode: true,
      centerPadding: '0px',
      dots: true,
      focusOnSelect: true,
      infinite: true,
      speed: 500,
      slidesToShow: getSlideCount(windowSize.width),
      slidesToScroll: 1,
      beforeChange: (_current: number, upcoming: number) => {
        setUpcomingSlide(upcoming);
      }
    };
  }, [windowSize]);

  return (
    <div className="text-center p-12">
      <h2 className="text-4xl font-bold mb-8">Promokuvia</h2>
      <div className="promo-photos m-auto">
        <Slider {...sliderSettings}>
          {
            promoPhotos.map((photo, index) => (
              <div className="text-center" key={index}>
                <img
                  className={classNames('m-auto cursor-pointer', {
                    'active-slide': index === upcomingSlide
                  })}
                  key={index}
                  src={photo} alt="LauriMikael"
                  onClick={() => {
                    if (index === upcomingSlide) {
                      setFullImage(photo);
                    }
                  }}
                />
              </div>
            ))
          }
        </Slider>

        <p className="p-2 text-right w-full pt-8 sm:pt-2">
          <a
            href="https://www.instagram.com/eveliinasphotography/"
            target="_blank"
            rel="noreferrer"
          >
            &copy; Eveliina Gutierrez
          </a>
        </p>
      </div>
      {
        fullImage &&
        <div
          className="fixed left-0 top-0 w-full h-full text-center z-10 flex justify-center"
          style={{ background: "rgba(0, 0, 0, 0.8)" }}
          onClick={() => setFullImage(null)}
        >
          <img
            src={fullImage} alt="LauriMikael"
            className="m-auto z-10 max-h-full"
          />
        </div>
      }
    </div>
  )
};

export default PromoImageView;